import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { Scrollbars } from 'react-custom-scrollbars';
import Typograf from 'typograf';

import ArrowIcon from 'assets/svg/arrow.component.svg';
import {
    formatDeliveryDateMobile,
    formatDeliveryDateMobileSelect,
    formatInterval,
    areDatesInDifferentPeriods,
} from 'app/utils/date';

import { withLocaleContext } from 'app/containers/LocaleProvider';

import { locales } from './deliveryDate.locales';

import mobileStyles from './delivery-date-desktop.scss'; // eslint-disable-line
import styles from './deliverydate.scss';


const tp = new Typograf({ locale: ['ru', 'en-US'] });


const animationClasses = {
    enter: styles.daysEnter,
    enterActive: styles.daysEnterActive,
    exit: styles.daysExit,
    exitActive: styles.daysExitActive,
};
const optionHeight = 50;


class DateAndTimeSelectDesktop extends React.Component {
    state = {
        daySelectIsOpen: false,
        timeSelectIsOpen: false,
    };

    daySelectRef = React.createRef();

    selectedDayNode = React.createRef();

    daySelectContainerRef = React.createRef();

    timeSelectRef = React.createRef();

    selectedTimeNode = React.createRef();

    timeSelectContainerRef = React.createRef();

    constructor(props) {
        super(props);
        const { daySelectIsOpen, timeSelectIsOpen } = this.props;
        // for profile open select
        this.state.daySelectIsOpen = daySelectIsOpen;
        this.state.timeSelectIsOpen = timeSelectIsOpen;
    }

    // for profile scroll select
    componentDidMount() {
        this.scrollSelectors();
    }

    componentDidUpdate() {
        this.scrollSelectors();
    }

    scrollSelectors = () => {
        const {
            daySelectIsOpen,
            timeSelectIsOpen,
        } = this.state;

        if (daySelectIsOpen || timeSelectIsOpen) {
            document.addEventListener('click', this.handleCloseSelect, false);
        } else {
            document.removeEventListener('click', this.handleCloseSelect, false);
        }

        if (timeSelectIsOpen && this.selectedTimeNode) {
            this.timeSelectContainerRef.current.scrollTop(
                // - optionHeigh для попадания активного элемента под курсор
                this.selectedTimeNode.offsetTop - optionHeight,
            );
        }
        if (daySelectIsOpen && this.selectedDayNode) {
            this.daySelectContainerRef.current.scrollTop(
                // - optionHeigh для попадания активного элемента под курсор
                this.selectedDayNode.offsetTop - optionHeight,
            );
        }
    };

    handleCloseSelect = (e) => {
        const { onCloseSelect } = this.props;
        const daySelect = this.daySelectRef.current;
        const timeSelect = this.timeSelectRef.current;

        if (daySelect && daySelect.contains(e.target)) return;
        if (timeSelect && timeSelect.contains(e.target)) return;

        this.closeLocalSelects();
        onCloseSelect();
    };

    handleToggleDay = (e) => {
        e?.preventDefault();
        e?.stopPropagation();

        const { onToggleDay } = this.props;
        const { daySelectIsOpen } = this.state;

        const nextOpenState = !daySelectIsOpen;
        this.setState({
            daySelectIsOpen: !daySelectIsOpen,
        });

        onToggleDay({ isOpen: nextOpenState });
    };

    handleToggleTime = (e) => {
        e?.preventDefault();
        e?.stopPropagation();

        const { onToggleTime } = this.props;
        const { timeSelectIsOpen } = this.state;

        const nextOpenState = !timeSelectIsOpen;
        this.setState({
            timeSelectIsOpen: nextOpenState,
        });

        onToggleTime({ isOpen: nextOpenState });
    };

    handleSelectDay = (e) => {
        const { currentTarget: { dataset: { day } } } = e;
        const {
            selectDay,
            isPromoPage,
            isTrial,
            onSelectDay,
            onChangeDateConfirm,
            displayDatesConfirmDialog,
        } = this.props;

        if (isTrial || isPromoPage) {
            onSelectDay(day);
            this.handleToggleDay();
            return;
        }

        const isNextDateInAnotherPeriod = areDatesInDifferentPeriods(selectDay, day);

        if (isNextDateInAnotherPeriod) {
            const onConfirm = () => {
                onChangeDateConfirm(day);
                onSelectDay(day);
            };
            displayDatesConfirmDialog(onConfirm);
            this.handleToggleDay();
        } else {
            onSelectDay(day);
            this.handleToggleDay();
        }
    };

    handleSelectTime = (e) => {
        const { target: { dataset: { timeperiod, timeindex } } } = e;
        const { onSelectTime } = this.props;
        onSelectTime(timeperiod, Number(timeindex));
        this.handleToggleTime();
    };

    handleSelectTimeInterval = (e) => {
        const { currentTarget: { dataset: { intervalIndex } } } = e;
        const { onSelectInterval, intervals } = this.props;
        onSelectInterval(intervals[Number(intervalIndex)]);
        this.handleToggleTime();
    };

    handleKeyDownOnDay = (e) => {
        const { daySelectIsOpen } = this.state;
        const {
            onSelectDay, selectDay, dates,
        } = this.props;

        if (!daySelectIsOpen) return;

        const currentIndex = dates.findIndex((d) => d.date === selectDay);

        switch (e.keyCode) {
            case 40: { // down
                e.preventDefault();

                const nextSelectDay = dates[currentIndex + 1];
                if (nextSelectDay && nextSelectDay.enabled) {
                    onSelectDay(nextSelectDay.date);
                }
                break;
            }
            case 38: { // up
                e.preventDefault();
                const nextSelectDay = dates[currentIndex - 1];
                if (nextSelectDay && nextSelectDay.enabled) {
                    onSelectDay(nextSelectDay.date);
                }
                break;
            }
            case 9: // tab
            case 13: // enter
            case 27: // esc
                this.handleToggleDay();
                e.preventDefault();
                break;
            default:
        }
    };


    VerticalScrollThumb = () => <div styleName="styles.scroll-thumb" />;

    VerticalScrollTrack = () => <div styleName="styles.vertical-scroll-track" />;

    closeLocalSelects() {
        this.setState(() => ({
            daySelectIsOpen: false,
            timeSelectIsOpen: false,
        }));
    }

    canShowDatesDelimiter(currentDateIndex, lastPeriodDateIndex) {
        const { periodEndDate, isTrial, dates } = this.props;
        return periodEndDate && currentDateIndex === lastPeriodDateIndex && !isTrial && dates.length - 1 !== currentDateIndex;
    }

    render() {
        const {
            localeContext: { locale },

            size,
            dates,
            intervals,
            timeIntervals,
            // selectedInterval,
            selectedInterval: {
                hourFrom,
                hourTo,
                hour_from,
                minute_from: mf,
                minuteFrom,
                hour_to,
                minute_to: mt,
                minuteTo,
            },
            selectDay,
            selectTime,
            selectedTimeText,
            isTimeChange,
            tabIndexDate,
            tabIndexTime,
            dayToggleRef,
            isTrial,

            disabled,
            isDaySelectDisabled,
            isTimeSelectDisabled: isTimeSelectDisabledProp,
            isDisabledInfoHidden,

            isDeliveryOutsideZone,
            isMobileShowMessageOnTimeChange,
            insideBetlwayTitle,
            hideStaticNotification,
            periodEndDate,
            isDayChangedAnimation,
            isTimeChangedAnimation,
            onEndDayAnimation,
            onEndTimeAnimation,
        } = this.props;

        const {
            daySelectIsOpen,
            timeSelectIsOpen,
        } = this.state;

        const l = locales[locale];
        const timeChanedText = l.timeChangedText;
        const disabledText = l.disabled;
        const deliveryZoneText = l.deliveryZone;
        const delimiterText = l.delimiter;
        const deliveryTimeOneIntervalText = l.deliveryTimeOneInterval;
        const deliveryTimeSelectText = l.deliveryTimeSelect;

        const { timeIndex } = selectTime;

        const timeChanedText2 = tp.execute(deliveryTimeSelectText);

        const hf = hourFrom || hour_from;
        const ht = hourTo || hour_to;

        const minF = mf || minuteFrom;
        const minT = mt || minuteTo;

        const activeShowTime = timeIntervals
            ? timeIntervals[timeIndex]
            : formatInterval(hf, ht, minF, minT);

        const lastPeriodDateIndex = dates.reduce((acc, date, i) => (new Date(date.date) <= new Date(periodEndDate) ? i : acc), null);
        const hasDatesDelimiter = dates.find((d) => new Date(d.date) > new Date(periodEndDate));
        const datesLength = (dates && dates.length);
        const timeIntervalsLength = (timeIntervals && timeIntervals.length) || (intervals && intervals.length);
        const isOneTimeInterval = timeIntervalsLength === 1;

        const isDateSelectDisabled = disabled || isDeliveryOutsideZone || isDaySelectDisabled;
        const isTimeSelectDisabled = disabled || isDeliveryOutsideZone || isTimeSelectDisabledProp;

        const { day, weekday, month } = formatDeliveryDateMobile(selectDay, locale);

        const hasEnabledDates = dates.find((d) => d.enabled);

        const selectClasses = classNames({
            'styles.delivery-date': true,
            [`styles.${size}`]: Boolean(size),
        });
        const timeTooltipClasses = classNames({
            'mobileStyles.mobile-dates__tip': true,
            'mobileStyles.open': isTimeChange,
        });
        const selectButtonDayClasses = classNames({
            'mobileStyles.select-button': true,
            'mobileStyles.disabled': isDateSelectDisabled || !selectDay || !hasEnabledDates,
            'mobileStyles.dayAnimationEnter': isDayChangedAnimation,
        });
        const selectButtonTimeClasses = classNames({
            'mobileStyles.select-button': true,
            'mobileStyles.disabled': isTimeSelectDisabled,
            'mobileStyles.timeAnimationEnter': isTimeChangedAnimation,
        });
        const timeIntervalsContainerClasses = classNames({
            'styles.delivery-date__options styles.scroll-container': true,
            'styles.h-time': true,
            [`styles.h-${timeIntervalsLength}`]: timeIntervalsLength >= 1 && timeIntervalsLength <= 6,
            'styles.one-option': isOneTimeInterval,
        });
        const datesContainerClasses = classNames({
            'styles.delivery-date__options styles.scroll-container': true,
            'styles.h-date': true,
            [`styles.h-${datesLength}`]: datesLength >= 1 && datesLength <= 6,
            'styles.one-option': datesLength === 1,
            'styles.has-delimiter': datesLength === 1 && hasDatesDelimiter,
        });

        const isNeededRenderDisabledInfo = !isDisabledInfoHidden && !isDeliveryOutsideZone && disabled;

        return (
            <>
                <div styleName={selectClasses}>
                    { /* eslint-disable-next-line jsx-a11y/no-static-element-interactions */ }
                    <div styleName="styles.delivery-date__select-wrap" onKeyDown={this.handleKeyDownOnDay}>
                        <button
                            type="button"
                            styleName={selectButtonDayClasses}
                            onClick={!isDateSelectDisabled ? this.handleToggleDay : null}
                            tabIndex={tabIndexDate}
                            ref={dayToggleRef}
                            onAnimationEnd={onEndDayAnimation}
                            aria-label="Выбрать дату доставки"
                        >
                            <div styleName="mobileStyles.select-value">
                                <div styleName="mobileStyles.select-date">
                                    {selectDay && (
                                        <>
                                            <div styleName="mobileStyles.select-date__weekday">{weekday}</div>
                                            <div styleName="mobileStyles.select-date__day">
                                                {day}
                                                /
                                                {month}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div styleName="mobileStyles.select-toggle">
                                <div styleName="mobileStyles.select-toggle-icon"><ArrowIcon /></div>
                            </div>
                        </button>
                        <CSSTransition
                            in={daySelectIsOpen}
                            timeout={150}
                            classNames={animationClasses}
                            unmountOnExit
                        >
                            <div styleName={datesContainerClasses} data-testid="delivery-date-options-container">
                                <Scrollbars
                                    renderThumbVertical={this.VerticalScrollThumb}
                                    renderTrackVertical={this.VerticalScrollTrack}
                                    ref={this.daySelectContainerRef}
                                >
                                    <ul styleName="styles.delivery-date__option-list" ref={this.daySelectRef}>
                                        {dates.map((d, i) => {
                                            const { day: dy, weekday: wd } = formatDeliveryDateMobileSelect(d.date, locale);
                                            const isActive = d.date === selectDay;

                                            const isDateDisabled = !d.enabled;

                                            const itemClasses = classNames({
                                                'styles.delivery-date__option': true,
                                                'styles.is-active': isActive,
                                                'styles.disabled': isDateDisabled,
                                            });

                                            return (
                                                <React.Fragment key={`${d.date}`}>
                                                    {(!isTrial && lastPeriodDateIndex === null && i === 0) && (
                                                        <div styleName="styles.delivery-date__option styles.delivery-date__option-subtitle">
                                                            {delimiterText}
                                                        </div>
                                                    )}
                                                    <li
                                                        styleName={itemClasses}
                                                        ref={(node) => { if (isActive) this.selectedDayNode = node; }}
                                                    >
                                                        <button
                                                            type="button"
                                                            onClick={this.handleSelectDay}
                                                            data-day={d.date}
                                                            tabIndex={-1}
                                                            disabled={isDateDisabled}
                                                            data-testid="delivery-date-option"
                                                        >
                                                            <div styleName="styles.delivery-date__button--wrap">
                                                                <div styleName="styles.delivery-date__button-weekday">
                                                                    {wd}
                                                                    ,
                                                                </div>
                                                                &nbsp;
                                                                <div styleName="styles.delivery-date__button-day">{dy}</div>
                                                            </div>
                                                        </button>
                                                    </li>
                                                    {!isTrial && this.canShowDatesDelimiter(i, lastPeriodDateIndex) && (
                                                        <div
                                                            styleName="styles.delivery-date__option styles.delivery-date__option-subtitle"
                                                        >
                                                            {delimiterText}
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })}
                                    </ul>
                                </Scrollbars>
                            </div>
                        </CSSTransition>
                    </div>
                    { /* eslint-disable-next-line jsx-a11y/no-static-element-interactions */ }
                    <div
                        styleName="styles.delivery-date__select-wrap"
                    >
                        <button
                            type="button"
                            styleName={selectButtonTimeClasses}
                            onClick={!isTimeSelectDisabled ? this.handleToggleTime : null}
                            tabIndex={tabIndexTime}
                            onAnimationEnd={onEndTimeAnimation}
                            aria-label="Выбрать время доставки"
                        >
                            <div styleName="mobileStyles.select-value">
                                <div styleName="mobileStyles.select-time">
                                    <div styleName="mobileStyles.select-time__interval">
                                        {selectedTimeText || (activeShowTime && `${activeShowTime.start} - ${activeShowTime.end}`)}
                                    </div>
                                </div>
                            </div>
                            <div styleName="mobileStyles.select-toggle">
                                <div styleName="mobileStyles.select-toggle-icon"><ArrowIcon /></div>
                            </div>
                        </button>
                        <CSSTransition
                            in={timeSelectIsOpen}
                            timeout={150}
                            classNames={animationClasses}
                            unmountOnExit
                        >
                            <div styleName={timeIntervalsContainerClasses}>
                                <Scrollbars
                                    renderThumbVertical={this.VerticalScrollThumb}
                                    autoHide
                                    ref={this.timeSelectContainerRef}
                                >
                                    <ul styleName="styles.delivery-date__option-list" ref={this.timeSelectRef}>
                                        {timeIntervals ? (
                                            <>
                                                <li
                                                    styleName="styles.delivery-date__option styles.inactive styles.title"
                                                >
                                                    <span styleName="styles.deivery-date__options-title">
                                                        {insideBetlwayTitle}
                                                    </span>
                                                </li>
                                                {
                                                    timeIntervals.map((d, i) => {
                                                        const isActive = i === timeIndex;
                                                        const isIntervalDisabled = !d.enabled;

                                                        const itemClasses = classNames({
                                                            'styles.delivery-date__option': true,
                                                            'styles.is-active': isActive,
                                                            'styles.disabled': isIntervalDisabled,
                                                        });

                                                        const isButtonDisabled = isIntervalDisabled;
                                                        return (
                                                            <li
                                                                styleName={itemClasses}
                                                                key={d.start + d.end + i}
                                                                ref={(node) => { if (isActive) this.selectedTimeNode = node; }}
                                                            >
                                                                <button
                                                                    type="button"
                                                                    onClick={this.handleSelectTime}
                                                                    data-timeindex={i}
                                                                    data-timeperiod="inside_mkad"
                                                                    disabled={isButtonDisabled}
                                                                >
                                                                    {d.start}
                                                                    {' '}
                                                                    -
                                                                    {' '}
                                                                    {d.end}
                                                                </button>
                                                            </li>
                                                        );
                                                    })
                                                }
                                            </>
                                        ) : (
                                            <>
                                                {intervals.map((interval, index) => {
                                                    const {
                                                        hourFrom,
                                                        minuteFrom,
                                                        hourTo,
                                                        minuteTo,
                                                        enabled,
                                                    } = interval;

                                                    const isActive = hf === hourFrom && ht === hourTo;

                                                    const itemClasses = classNames({
                                                        'styles.delivery-date__option': true,
                                                        'styles.is-active': isActive,
                                                        'styles.disabled': !enabled,
                                                    });
                                                    const text = formatInterval(hourFrom, hourTo, minuteFrom, minuteTo);

                                                    return (
                                                        <li
                                                            styleName={itemClasses}
                                                            key={`${hourFrom}:${minuteFrom}-${hourTo}:${minuteTo}`}
                                                            ref={(node) => { if (isActive) this.selectedTimeNode = node; }}
                                                        >
                                                            <button
                                                                type="button"
                                                                onClick={this.handleSelectTimeInterval}
                                                                data-interval-index={index}
                                                                disabled={!enabled}
                                                            >
                                                                {text.start}
                                                                {' '}
                                                                -
                                                                {' '}
                                                                {text.end}
                                                            </button>
                                                        </li>
                                                    );
                                                })}
                                            </>
                                        )}
                                        {isOneTimeInterval && (
                                            <li styleName="styles.delivery-date__option styles.one-block-text">
                                                {tp.execute(deliveryTimeOneIntervalText)}
                                                <br />
                                                {tp.execute(deliveryZoneText)}
                                            </li>
                                        )}
                                    </ul>
                                </Scrollbars>
                            </div>
                        </CSSTransition>
                    </div>
                </div>
                {!hideStaticNotification && (
                    <>
                        <div styleName={timeTooltipClasses}>
                            <div styleName="mobileStyles.select__date-time-info">
                                {timeChanedText2}
                            </div>
                        </div>
                        {isTimeChange && isMobileShowMessageOnTimeChange && (
                            <div styleName="mobileStyles.select__date-time-info mobileStyles.red">
                                {tp.execute(timeChanedText)}
                            </div>
                        )}
                        {isNeededRenderDisabledInfo && (
                            <div styleName="mobileStyles.select__date-time-info">
                                {tp.execute(disabledText)}
                            </div>
                        )}
                    </>
                )}
            </>
        );
    }
}

DateAndTimeSelectDesktop.propTypes = {
    dates: PropTypes.arrayOf(PropTypes.shape({

    })).isRequired,
    selectedInterval: PropTypes.shape({}),
    timeIntervals: PropTypes.arrayOf(PropTypes.shape({
        start: PropTypes.string,
        end: PropTypes.string,
    })),
    intervals: PropTypes.arrayOf(PropTypes.shape({
        hourFrom: PropTypes.number,
        hourTo: PropTypes.number,
    })),
    selectDay: PropTypes.string,
    selectTime: PropTypes.shape({
        timePeriod: PropTypes.string,
        timeIndex: PropTypes.number,
    }),
    selectedTimeText: PropTypes.string,

    onSelectDay: PropTypes.func,
    onSelectTime: PropTypes.func,
    onSelectInterval: PropTypes.func,
    onToggleTime: PropTypes.func,
    onToggleDay: PropTypes.func,
    onCloseSelect: PropTypes.func,
    displayDatesConfirmDialog: PropTypes.func,
    onChangeDateConfirm: PropTypes.func,

    isTimeChange: PropTypes.bool.isRequired,
    daySelectIsOpen: PropTypes.bool,
    timeSelectIsOpen: PropTypes.bool,

    tabIndexDate: PropTypes.string,
    tabIndexTime: PropTypes.string,
    dayToggleRef: PropTypes.shape({}),

    isDeliveryOutsideZone: PropTypes.bool,

    disabled: PropTypes.bool,
    isDaySelectDisabled: PropTypes.bool,
    isTimeSelectDisabled: PropTypes.bool,
    isDisabledInfoHidden: PropTypes.bool,

    isMobileShowMessageOnTimeChange: PropTypes.bool,
    insideBetlwayTitle: PropTypes.string,
    hideStaticNotification: PropTypes.bool,
    periodEndDate: PropTypes.string,
    isTrial: PropTypes.bool,
    isPromoPage: PropTypes.bool,
    isDayChangedAnimation: PropTypes.bool,
    isTimeChangedAnimation: PropTypes.bool,
    onEndDayAnimation: PropTypes.func,
    onEndTimeAnimation: PropTypes.func,
    size: PropTypes.oneOf(['wide', null]),
};

const DateAndTimeSelectDesktopFC = (props) => {
    const {
        onSelectDay = () => {},
        onSelectTime = () => {},
        onSelectInterval = () => {},
        onToggleTime = () => {},
        onToggleDay = () => {},
        onCloseSelect = () => {},
        displayDatesConfirmDialog = () => {},
        onChangeDateConfirm = () => {},
        selectDay = null,
        selectedInterval = {},
        size = null,
        timeIntervals = null,
        intervals = null,
        selectTime = {},
        daySelectIsOpen = false,
        timeSelectIsOpen = false,
        tabIndexDate = '0',
        tabIndexTime = '0',
        dayToggleRef = React.createRef(),
        selectedTimeText = null,
        isDeliveryOutsideZone = false,

        disabled = false,
        isDaySelectDisabled = false,
        isTimeSelectDisabled = false,
        isDisabledInfoHidden = false,

        isMobileShowMessageOnTimeChange = false,
        insideBetlwayTitle = 'Москва',
        hideStaticNotification = false,
        periodEndDate = '',
        isTrial = false,
        isPromoPage = false,
        isDayChangedAnimation = false,
        isTimeChangedAnimation = false,
        onEndDayAnimation = () => {},
        onEndTimeAnimation = () => {},
    } = props;
    return (
        <DateAndTimeSelectDesktop
            {...props}
            onSelectDay={onSelectDay}
            onSelectTime={onSelectTime}
            onSelectInterval={onSelectInterval}
            onToggleTime={onToggleTime}
            onToggleDay={onToggleDay}
            onCloseSelect={onCloseSelect}
            displayDatesConfirmDialog={displayDatesConfirmDialog}
            onChangeDateConfirm={onChangeDateConfirm}
            selectDay={selectDay}
            selectedInterval={selectedInterval}
            size={size}
            timeIntervals={timeIntervals}
            intervals={intervals}
            selectTime={selectTime}
            daySelectIsOpen={daySelectIsOpen}
            timeSelectIsOpen={timeSelectIsOpen}
            tabIndexDate={tabIndexDate}
            tabIndexTime={tabIndexTime}
            dayToggleRef={dayToggleRef}
            selectedTimeText={selectedTimeText}
            isDeliveryOutsideZone={isDeliveryOutsideZone}
            disabled={disabled}
            isDaySelectDisabled={isDaySelectDisabled}
            isTimeSelectDisabled={isTimeSelectDisabled}
            isDisabledInfoHidden={isDisabledInfoHidden}
            isMobileShowMessageOnTimeChange={isMobileShowMessageOnTimeChange}
            insideBetlwayTitle={insideBetlwayTitle}
            hideStaticNotification={hideStaticNotification}
            periodEndDate={periodEndDate}
            isTrial={isTrial}
            isPromoPage={isPromoPage}
            isDayChangedAnimation={isDayChangedAnimation}
            isTimeChangedAnimation={isTimeChangedAnimation}
            onEndDayAnimation={onEndDayAnimation}
            onEndTimeAnimation={onEndTimeAnimation}
        />
    );
};


export default withLocaleContext(DateAndTimeSelectDesktopFC);
